import React from 'react';
import { Link } from 'react-router-dom';
import subscriptionNotAvaialable from "../assets/SubscriptionNotAvaialable.svg"

function InvalidCredential() {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f0f0',
        padding: '0px',
        borderRadius: '8px',

      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '0px',
          width: '100%',
          height: '100vh',
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <img src={subscriptionNotAvaialable} alt="Error" style={{
            width: '250px',
            height: '250px',
            marginBottom: '30px',
          }} />
          <h1 style={{
            fontSize: '24px',
            marginBottom: '16px',
            color: '#333',
            textAlign: 'center',
          }}>Login Failed!</h1>
          <p style={{
            fontSize: '14px',
            lineHeight: '1.5',
            marginBottom: '40px',
            color: '#666',
            textAlign: 'center',
            maxWidth: '280px',
          }}>
            Invalid Credential Access. Please contact
            customer support 155-700 for assistance.
          </p>
          <div style={{
            width:'100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <Link to="/user-login" style={{
                display: 'inline-block',
                backgroundColor: '#2596be',
                color: 'white',
                width:'80%',
                textAlign: 'center',
                padding: '10px 20px',
                borderRadius: '4px',
                textDecoration: 'none',
                fontSize: '16px',
                alignSelf:'center'
            }}>
                Close
            </Link>
          </div>
        </div>
      </div>
    );
  }
export default InvalidCredential;